import classNames from 'classnames';
import React, { useContext, useState, useEffect } from 'react';
import { UploadContext } from 'ricos-context';
import { getImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { Uploader } from 'wix-rich-content-plugin-commons';
import { SettingsSection, Label, SettingsAddItem, SettingsSeparator, LabeledToggle, SettingsPanelFooter, InputWithLabel, SettingsMobileHeader, SettingsPanelHeader } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { AUDIO_ACTION_NAMES, AUDIO_TYPES, SETTINGS_IMG_SIZE, AUDIO_BI_VALUES } from '../consts.js';
import { AUDIO_SETTINGS_AUDIO_NAME_INPUT, AUDIO_SETTINGS_AUTHOR_NAME_INPUT, AUDIO_SETTINGS_MODAL, AUDIO_COVER_IMAGE, AUDIO_DOWNLOAD_TOGGLE } from '../dataHooks.js';
import { AudioPluginService } from '../toolbar/audioPluginService.js';
import { AUDIO_TYPE } from 'ricos-content';
import 'ricos-types';
import 'lodash';

var css_248z = ".glob_fontElementMap,.v5yRc{font-family:var(--ricos-font-family,unset)}[dir=ltr] .-e9CA{text-align:left}[dir=rtl] .-e9CA{text-align:right}.Vd3Iw{display:flex;flex-direction:column;gap:20px}[dir] .Vd3Iw{margin-bottom:32px}.zamr-{box-sizing:border-box;height:calc(100% - 177px);overflow:scroll;position:absolute;width:100%}[dir] .zamr-{margin:77px auto 100px;padding:20px}[dir=ltr] .zamr-{text-align:left}[dir=rtl] .zamr-{text-align:right}.zamr- *,.zamr- :after,.zamr- :before{box-sizing:inherit}.zamr- input{box-sizing:border-box}.boazl .zamr-{height:calc(100% - 50px)}[dir] .boazl .zamr-{margin:50px auto auto}._9j3C1{position:relative}[dir] ._9j3C1{margin-top:16px}.xW8Oz{color:var(--ricos-settings-text-color,var(--ricos-text-color-low,#646464));font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:14px;height:40px;line-height:20px;width:163px}[dir] .xW8Oz{margin-top:4px}";
var styles = {"fontElementMap":"v5yRc","audio_settings":"-e9CA","audio_settings_inputs_wrapper":"Vd3Iw","audio_settings_wrapper":"zamr-","audio_settings_mobile":"boazl","audio_settings_coverImage_wrapper":"_9j3C1","audio_settings_download_label":"xW8Oz"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const AudioSettings = (props) => {
  var _a;
  const {
    onCancel,
    onSave,
    updateData,
    componentData,
    helpers,
    t,
    isMobile,
    handleFileSelection,
    handleFileUpload,
    getComponentData,
    blockKey
  } = props;
  const { uploadService } = useContext(UploadContext);
  const initialState = {
    name: componentData == null ? void 0 : componentData.name,
    authorName: componentData == null ? void 0 : componentData.authorName,
    disableDownload: componentData == null ? void 0 : componentData.disableDownload,
    coverImage: componentData == null ? void 0 : componentData.coverImage
  };
  const [isDownloadEnabled, setIsDownloadEnabled] = useState(!(initialState == null ? void 0 : initialState.disableDownload));
  const [coverImage, setCoverImage] = useState((initialState == null ? void 0 : initialState.coverImage) || null);
  const [name, setName] = useState(initialState.name || "");
  const [authorName, setAuthorName] = useState(initialState.authorName || "");
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const onDownlandToggle = () => {
    var _a2;
    setIsDownloadEnabled(!isDownloadEnabled);
    const toggleBIValue = isDownloadEnabled ? AUDIO_BI_VALUES.NO : AUDIO_BI_VALUES.YES;
    (_a2 = helpers == null ? void 0 : helpers.onChangePluginSettings) == null ? void 0 : _a2.call(helpers, {
      pluginId: AUDIO_TYPE,
      actionName: AUDIO_ACTION_NAMES.downloadAudio,
      value: toggleBIValue
    });
  };
  const onInputBlur = (actionName, value) => {
    var _a2;
    (_a2 = helpers == null ? void 0 : helpers.onChangePluginSettings) == null ? void 0 : _a2.call(helpers, {
      pluginId: AUDIO_TYPE,
      actionName,
      value
    });
  };
  const AudioPluginService$1 = new AudioPluginService();
  const handleFilesAdded = (args) => {
    var _a2;
    const img = args.data[0] || args.data;
    setCoverImage(img);
    setIsLoadingImage(false);
    (_a2 = helpers == null ? void 0 : helpers.onChangePluginSettings) == null ? void 0 : _a2.call(helpers, {
      pluginId: AUDIO_TYPE,
      actionName: AUDIO_ACTION_NAMES.changeCover,
      value: AUDIO_BI_VALUES.YES
    });
  };
  const closeModal = () => {
    return onCancel == null ? void 0 : onCancel();
  };
  const onFileSelection = () => {
    const fromSettings = true;
    handleFileSelection == null ? void 0 : handleFileSelection(handleFilesAdded, void 0, fromSettings, componentData);
  };
  const handleFileChange = async ([file]) => {
    var _a2;
    if (uploadService) {
      const uploader = new Uploader(handleFileUpload);
      setIsLoadingImage(true);
      await uploadService.uploadFile(file, blockKey, uploader, AUDIO_TYPE, AudioPluginService$1);
      setCoverImage((_a2 = getComponentData == null ? void 0 : getComponentData()) == null ? void 0 : _a2.coverImage);
      setIsLoadingImage(false);
    }
  };
  const handleCoverImageDelete = () => {
    var _a2;
    setCoverImage(null);
    (_a2 = helpers == null ? void 0 : helpers.onChangePluginSettings) == null ? void 0 : _a2.call(helpers, {
      pluginId: AUDIO_TYPE,
      actionName: AUDIO_ACTION_NAMES.changeCover,
      value: AUDIO_BI_VALUES.NO
    });
  };
  const inputsData = [
    {
      label: t("AudioPlugin_Settings_AudioName_Label"),
      value: name,
      onChange: (value) => setName(value),
      dataHook: AUDIO_SETTINGS_AUDIO_NAME_INPUT,
      placeholder: t("AudioPlugin_Settings_AudioName_Label_Placeholder"),
      onBlur: (e) => onInputBlur(AUDIO_ACTION_NAMES.changeTitle, e.target.value)
    },
    {
      label: t("AudioPlugin_Settings_AuthorName_Label"),
      value: authorName,
      onChange: (value) => setAuthorName(value),
      dataHook: AUDIO_SETTINGS_AUTHOR_NAME_INPUT,
      placeholder: t("AudioPlugin_Settings_AuthorName_Label_Placeholder"),
      onBlur: (e) => onInputBlur(AUDIO_ACTION_NAMES.changeCreator, e.target.value)
    }
  ];
  const renderInputs = () => inputsData.map((props2) => /* @__PURE__ */ React.createElement(InputWithLabel, __spreadValues({ key: props2.dataHook }, props2)));
  const renderHeader = () => isMobile ? /* @__PURE__ */ React.createElement(
    SettingsMobileHeader,
    {
      t,
      title: t("AudioPlugin_Settings_Header"),
      onCancel: closeModal,
      onSave
    }
  ) : /* @__PURE__ */ React.createElement(SettingsPanelHeader, { title: t("AudioPlugin_Settings_Header"), onClose: closeModal });
  const imgSrc = coverImage && getImageSrc({ file_name: ((_a = coverImage.src) == null ? void 0 : _a.id) || (coverImage == null ? void 0 : coverImage.file_name) }, helpers == null ? void 0 : helpers.getImageUrl, {
    requiredWidth: 120,
    requiredHeight: 120,
    requiredQuality: 70
  });
  useEffect(() => {
    var _a2;
    updateData == null ? void 0 : updateData(__spreadProps(__spreadValues({}, componentData), {
      name,
      authorName,
      disableDownload: !isDownloadEnabled,
      coverImage: coverImage ? { src: { id: ((_a2 = coverImage == null ? void 0 : coverImage.src) == null ? void 0 : _a2.id) || (coverImage == null ? void 0 : coverImage.file_name) } } : null
    }));
    return () => {
      var _a3;
      const { duration, src } = componentData.audio;
      (_a3 = helpers == null ? void 0 : helpers.mediaPluginsDetails) == null ? void 0 : _a3.call(helpers, {
        pluginId: AUDIO_TYPE,
        creator: authorName,
        title: name,
        track_duration: duration == null ? void 0 : duration.toString(),
        type: AUDIO_TYPES.custom,
        url: src.id
      });
    };
  }, [name, authorName, isDownloadEnabled, coverImage]);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-hook": AUDIO_SETTINGS_MODAL,
      className: classNames(styles.audio_settings, {
        [styles.audio_settings_mobile]: isMobile
      })
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.audio_settings_wrapper }, /* @__PURE__ */ React.createElement(SettingsSection, { className: classNames(styles.audio_settings_inputs_wrapper) }, renderInputs()), /* @__PURE__ */ React.createElement(SettingsSection, null, /* @__PURE__ */ React.createElement(Label, { label: t("AudioPlugin_Settings_CoverImage_Label") }), /* @__PURE__ */ React.createElement("div", { className: styles.audio_settings_coverImage_wrapper }, /* @__PURE__ */ React.createElement(
      SettingsAddItem,
      {
        handleFileChange,
        handleFileSelection: (helpers.handleFileSelection || handleFileSelection) && onFileSelection,
        isMobile,
        size: {
          height: Number(SETTINGS_IMG_SIZE.replace("px", "")),
          width: Number(SETTINGS_IMG_SIZE.replace("px", ""))
        },
        uploadMediaLabel: t("AudioPlugin_Settings_CoverImage_Label"),
        dataHook: AUDIO_COVER_IMAGE,
        inlineStyle: { width: SETTINGS_IMG_SIZE, height: SETTINGS_IMG_SIZE, marginLeft: 0 },
        src: imgSrc,
        handleDelete: handleCoverImageDelete,
        t,
        alt: name,
        hasReplace: true,
        isLoading: isLoadingImage
      }
    ))), /* @__PURE__ */ React.createElement(SettingsSeparator, { top: true }), /* @__PURE__ */ React.createElement(SettingsSection, { className: classNames(styles.audio_settings_toggle_wrapper) }, /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        checked: isDownloadEnabled,
        label: t("AudioPlugin_Settings_AudioCanBeDownloaded_Label"),
        onChange: onDownlandToggle,
        tooltipText: t("AudioPlugin_Settings_AudioCanBeDownloaded_Tooltip"),
        dataHook: AUDIO_DOWNLOAD_TOGGLE,
        isMobile
      }
    )), isMobile && /* @__PURE__ */ React.createElement("div", { className: classNames(styles.audio_settings_download_label) }, t("AudioPlugin_Settings_AudioCanBeDownloaded_Tooltip")))
  ), !isMobile && /* @__PURE__ */ React.createElement(SettingsPanelFooter, { fixed: true, cancel: closeModal, save: onSave, t }), renderHeader());
};

export { AudioSettings as default };
//# sourceMappingURL=AudioSettings.js.map
